import { apiClient } from '../http.js';

/**
 * Cobrança pela web, via checkout embedded do Stripe.
 *
 * Encapsula exatamente o fluxo que antes vivia solto no PlanGrid.jsx:
 * POST /billing/checkout devolve um client_secret que o CheckoutWidget monta.
 * Nenhuma mudança de comportamento — só saiu do componente para que a versão
 * nativa possa trocar a implementação sem tocar na UI.
 */
export const stripeProvider = {
    getKind: () => 'stripe',

    canPurchase: () => true,

    // Na web o catálogo vem de GET /billing/plans (services/planCatalog.js) e
    // já chega pronto na UI — não há um "offering" separado como no
    // RevenueCat, onde os preços vêm da loja.
    listOfferings: async () => [],

    purchase: async (plan, { billingCycle }) => {
        const { res, data } = await apiClient.request('/billing/checkout', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                plan_id: plan.plan_id,
                billing_cycle: billingCycle,
                idempotency_key: crypto.randomUUID(),
            }),
        });

        if (!res.ok) {
            throw new Error(data?.detail || 'Erro ao iniciar checkout');
        }
        if (!data?.client_secret) {
            throw new Error('Chave de checkout ausente na resposta.');
        }

        return { success: true, kind: 'stripe', clientSecret: data.client_secret };
    },

    // Não se aplica ao Stripe: a assinatura está atrelada à conta no backend,
    // não a um recibo de loja que precise ser restaurado no dispositivo.
    restorePurchases: async () => ({ restored: false }),
};
